// Vendors

// Angular 2
import '@angular/platform-browser-dynamic';
import '@angular/platform-browser';
import '@angular/core';
import '@angular/http';
import '@angular/router';


// RxJS 5
// import 'rxjs/Rx';
import 'rxjs/add/operator/map';

// For vendors for example jQuery, Lodash, angular2-jwt import them here
// Also see src/typings.d.ts as you also need to run `typings install x` where `x` is your module

import 'expose-loader?jQuery!jquery';
import '../node_modules/signalr/jquery.signalR.js';


import '../app/shared/drag_drop_touch/DragDropTouch.js';


// WEBPACK FOOTER //
// ./app/vendor.ts